module.exports = __webpack_public_path__ + "static/img/01.7ee808d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour2/01.jpg
// module id = l8fT
// module chunks = 0